module.exports = __webpack_public_path__ + "static/icon_renewal-4ddd6cfdd014c7b621295b740830c462.svg";